import { Injectable } from "@angular/core";
import { DwModalConfig, DwModalButtonStandardConfigs, DwModalSize, DwActionResult, DwModalService, DwEventService, DwOrmDataService } from "@devwareapps/devware-cap";

import { SchoolSelectionModalComponent } from "../../admin/components/school-selection-modal/school-selection-modal.component";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { PurchaseCourseModalComponent } from "../components/purchase-course-modal/purchase-course-modal.component";
import { PurchaseCourseModalConfig } from "../models/purchase-course-modal-config.model";
import { AppMetaDataItemNames } from "../../../meta-data/app-meta-data.service";

@Injectable({
    providedIn: 'root'
    })
export class PaymentPurchaseService {

    constructor(private dwModalService: DwModalService, private dwEventService: DwEventService) { }

    showPurchaseCourseModal(purchaseCourseConfig: PurchaseCourseModalConfig): Observable<DwActionResult> {
        let modalConfig = new DwModalConfig<PurchaseCourseModalConfig>();

        modalConfig.buttons = [DwModalButtonStandardConfigs.instance.okButton];
        modalConfig.buttons[0].buttonText = 'Purchase';
        
        DwModalButtonStandardConfigs.instance.okAndClose;
        
        modalConfig.allowFullScreen = false;
        modalConfig.modalSize = DwModalSize.responsive;

        modalConfig.component = PurchaseCourseModalComponent;

        modalConfig.data = purchaseCourseConfig;
        modalConfig.title = 'Purchase Course';


        return this.dwModalService.showModal<any,any>(modalConfig)
            .pipe(map(modalResult => {
                const result = new DwActionResult();

                if (modalResult.cancelled) {
                    result.cancelled = true;

                    return result;
                }

                this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.Course), {});

                result.success = true;
                result.message = 'Course Purchased successfully';

                return result;
            }));
    }
}